import React from "react";
import { Plus, LineChart, ClipboardPlus, Info, X } from "lucide-react";
import { CryptoLogo } from "../common/CryptoBits";
import { fmtPrice, fmtPct } from "../../lib/format";

export function FavoritePairCard({ pair, data, active, onSelect, onOpenChart, onCreatePlan, onDetails, onRemove }) {
  const change = data?.change24h ?? 0;
  const pos = change >= 0;
  const long = data?.longScore;
  const short = data?.shortScore;
  const color = pair.color || "#8b5cf6";

  return (
    <div
      onClick={() => onSelect(pair.symbol)}
      className={`ym-card ym-hover relative p-3.5 cursor-pointer group ${active ? "ym-glow-purple" : ""}`}
      style={{ borderColor: active ? "rgba(139,92,246,.5)" : "var(--border)", minWidth: 226 }}
    >
      <button
        onClick={(e) => { e.stopPropagation(); onRemove(pair.id); }}
        className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 grid place-items-center rounded-md ym-hover"
        style={{ width: 22, height: 22, background: "var(--panel-2)", border: "1px solid var(--border)" }}
        title="Remove"
      >
        <X size={12} style={{ color: "var(--text-muted)" }} />
      </button>

      <div className="flex items-center gap-2.5 mb-3">
        <CryptoLogo base={pair.base} color={color} size={30} />
        <div className="leading-tight">
          <div className="text-[13px] font-bold">{pair.base}<span style={{ color: "var(--text-dim)" }}>/USDT</span></div>
          <div className="text-[9px]" style={{ color: "var(--text-dim)" }}>{data?.provider || "…"}</div>
        </div>
        <span className="ml-auto pill" style={{ color: pos ? "var(--green)" : "var(--red)", background: pos ? "rgba(34,197,94,.12)" : "rgba(239,68,68,.12)", borderColor: "transparent" }}>
          {fmtPct(change)}
        </span>
      </div>

      <div className="text-[20px] font-bold tabnum mb-3">
        {data ? `$${fmtPrice(data.price)}` : "—"}
      </div>

      <div className="grid grid-cols-3 gap-1.5 mb-3">
        <ScoreChip label="Long" value={long} color="var(--green)" />
        <ScoreChip label="Short" value={short} color="var(--red)" />
        <div className="rounded-lg px-2 py-1.5 text-center" style={{ background: "var(--panel-2)", border: "1px solid var(--border)" }}>
          <div className="text-[8px] font-semibold tracking-wide" style={{ color: "var(--text-dim)" }}>REGIME</div>
          <div className="text-[10px] font-bold capitalize truncate" style={{ color: "var(--accent-soft)" }}>{data?.regime || "—"}</div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-1.5">
        <MiniBtn icon={LineChart} label="Chart" onClick={(e) => { e.stopPropagation(); onOpenChart(pair.symbol); }} />
        <MiniBtn icon={ClipboardPlus} label="Plan" onClick={(e) => { e.stopPropagation(); onCreatePlan(pair.symbol); }} accent />
        <MiniBtn icon={Info} label="Details" onClick={(e) => { e.stopPropagation(); onDetails(pair.symbol); }} />
      </div>
    </div>
  );
}

function ScoreChip({ label, value, color }) {
  return (
    <div className="rounded-lg px-2 py-1.5 text-center" style={{ background: "var(--panel-2)", border: "1px solid var(--border)" }}>
      <div className="text-[8px] font-semibold tracking-wide" style={{ color: "var(--text-dim)" }}>{label.toUpperCase()}</div>
      <div className="text-[13px] font-bold tabnum" style={{ color }}>{value ?? "—"}</div>
    </div>
  );
}

function MiniBtn({ icon: Icon, label, onClick, accent }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center justify-center gap-1 rounded-lg py-1.5 text-[10px] font-semibold ym-hover"
      style={{
        background: accent ? "rgba(139,92,246,.16)" : "var(--panel-2)",
        color: accent ? "var(--accent-soft)" : "var(--text-muted)",
        border: `1px solid ${accent ? "rgba(139,92,246,.35)" : "var(--border)"}`,
      }}
    >
      <Icon size={12} /> {label}
    </button>
  );
}

export function AddPairCard({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="ym-card ym-hover flex flex-col items-center justify-center gap-2 cursor-pointer"
      style={{ minWidth: 150, borderStyle: "dashed", borderColor: "var(--border)" }}
    >
      <div className="grid place-items-center rounded-full" style={{ width: 34, height: 34, background: "rgba(139,92,246,.14)", border: "1px solid rgba(139,92,246,.3)" }}>
        <Plus size={18} style={{ color: "var(--accent-soft)" }} />
      </div>
      <span className="text-[12px] font-semibold" style={{ color: "var(--text-muted)" }}>Tambah Pair</span>
    </button>
  );
}
